<template>
    <div>
        <div class="setting-wrapper">
            <div class="setting">
                <h4 class="lg:w-1/5">
                    {{ lang('Kanalpaket','TV channel package') }}
                </h4>

                <div class="w-full">
                    <tv-package-option
                        v-for="(tvPackage, i) in tvPackages"
                        :key="tvPackage.article_id"
                        v-model="localSelectedTvPackages"
                        :tv-package="tvPackage"
                        :class="{ 'mb-md': i < tvPackages.length - 1 }"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import TvPackageOption from './TvPackageOption';

    export default {
        components: {
            TvPackageOption,
        },
        model: {
            prop: 'selectedTvPackages',
            event: 'input',
        },
        props: {
            tvPackages: {
                type: Array,
                required: true,
            },
            selectedTvPackages: {
                type: Array,
                required: false,
                default: () => [],
            },
        },
        data() {
            return {
                toggled: false,
                selected: false,
            };
        },
        computed: {
            localSelectedTvPackages: {
                get() {
                    return this.selectedTvPackages;
                },
                set(localState) {
                    this.$emit('input', localState);
                },
            },
        },
        methods: {
            toggle() {
                this.toggled = ! this.toggled;
            },
        },
    };
</script>